import React from "react";
import "./ComprehensiveSolutions.css";
import heroImg from "../assets/images/b2b-hero.jpg";
import imageSection from "../assets/images/your-image.jpg";
import cardImg from "../assets/images/card-image.png";


export default function ComprehensiveSolutions() {
  return (
    <div className="b2b-page">

      {/* HERO SECTION */}
      <section
        className="b2b-hero"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="hero-overlay">
          <div className="hero-content container">
            <h1>
              We build relations with partners that share our commitment to offering accessible quality healthcare for all
            </h1>
          </div>
        </div>
      </section>

      {/* OUT LICENSING SECTION */}
     <section className="out-licensing">
  <div className="out-container">

    <div className="out-left">
      <h2>
        Out-licensing <br />
        <span>Full service</span>
      </h2>
    </div>

    <div className="out-right">
      <p>
        The B2B unit of Cinfa Group specialises in out-licensing. We offer
        an extensive portfolio of dossiers to our partners that meet the
        highest international quality standards, both for prescription
        medicines and OTC products, while anticipating market trends and needs.
      </p>

      <p>
        This business unit includes all the necessary departments to guarantee
        success for the projects undertaken with our partners. From the moment
        our strong R&D team begins the development process and all the way
        through to commercialisation, our sales and supply chain department,
        regulatory department, quality department and business intelligence
        department all offer their support throughout the process. All of them
        are essential links to our manufacturing plants.
      </p>
    </div>

  </div>
</section>
{/* IMAGE SECTION */}
<section
  style={{
    position: "relative",
    width: "100%",
    height: "500px",
    backgroundImage: `url(${imageSection})`, // replace with your image variable
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  {/* Gradient Overlay */}
  <div
  style={{
    position: "absolute",
    inset: 0,
    background: `
      /* Top Fade */
      linear-gradient(to bottom, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0) 40%),

      /* Bottom Strong White */
      linear-gradient(to top, rgba(255,255,255,1) 0%, rgba(255,255,255,0.95) 30%, rgba(255,255,255,0) 70%),

      /* Left Fade */
      linear-gradient(to right, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0) 35%),

      /* Right Fade */
      linear-gradient(to left, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0) 35%)
    `,
  }}
/>
</section>
{/* FEATURES SECTION */}

   <section class="cards-wrapper">
<div className="card-row">
  <div className="card" style={{ backgroundImage: `url(${cardImg})` }}>
    <div className="card-content">
      <h2>Commercial team</h2>
      <p>
        A team with expertise in the negotiation of licences that is focused on
        accompaniment and customised service to each partner.
      </p>
    </div>
  </div>

  <div className="card" style={{ backgroundImage: `url(${cardImg})` }}>
    <div className="card-content">
      <h2>Business Intelligence</h2>
      <p>
        A team focused on identifying opportunities and trends for developing a
        high value-added portfolio.
      </p>
    </div>
  </div>

  <div className="card" style={{ backgroundImage: `url(${cardImg})` }}>
    <div className="card-content">
      <h2>Proprietary R&D</h2>
      <p>
        Two proprietary R&D centres with extensive experience in developments
        for various markets.
      </p>
    </div>
  </div>
</div>


<div className="card-row">
  <div className="card" style={{ backgroundImage: `url(${cardImg})` }}>
    <div className="card-content">
      <h2>International records</h2>
      <p>
        A team with expertise in the preparation of dossiers and ongoing support
        throughout all stages of the product life cycle for interaction with
        all the main agencies worldwide.
      </p>
    </div>
  </div>

  <div className="card" style={{ backgroundImage: `url(${cardImg})` }}>
    <div className="card-content">
      <h2>Customer Service y Supply chain</h2>
      <p>
        Teams that act as links between the group's manufacturing plants to
        ensure the success of product launches, orders, shipments and other
        needs expressed by our partners.
      </p>
    </div>
  </div>

  <div className="card" style={{ backgroundImage: `url(${cardImg})` }}>
    <div className="card-content">
      <h2>Proprietary plants</h2>
      <p>
        We have three medicine manufacturing plants in Spain that meet the
        very highest standards of quality.
      </p>
    </div>
  </div>
</div>

</section>
</div>
  );
}